var _style, _path, _path2, _path3, _defs, _g, _path4, _path5, _defs2, _path6, _defs3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinGateawayOnStateUnChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3BDC65;fill-opacity:0.2;}\n\t.st1{fill:#3BDC65;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_2_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{fill:#FFFFFF;stroke:#354052;}\n\t.st7{clip-path:url(#SVGID_6_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,13C0,5.8,5.8,0,13,0l0,0c7.2,0,13,5.8,13,13l0,0c0,7.2-5.8,13-13,13l0,0C5.8,26,0,20.2,0,13L0,13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,4.3c-3.5,0-6.3,2.7-6.3,6.1c0,4.6,6.3,11.3,6.3,11.3s6.3-6.7,6.3-11.3C19.3,7,16.5,4.3,13,4.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,22.9l1.3-1.2l1.3,1.2L13,24.3L11.7,22.9z M14.2,20.3c1.8-2.2,5.1-6.6,5.1-9.9c0-3.4-2.8-6.1-6.3-6.1 c-3.5,0-6.3,2.7-6.3,6.1c0,3.3,3.3,7.7,5.1,9.9c0.7,0.9,1.2,1.4,1.2,1.4c-1.3,1.2-1.3,1.2-1.3,1.2l0,0l0,0l0,0l-0.1-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.2-0.4-0.5-0.7-0.9C10,21,9.2,20,8.4,18.8c-0.8-1.2-1.7-2.5-2.3-3.9c-0.6-1.4-1.2-2.9-1.2-4.4 C4.9,6,8.6,2.5,13,2.5c4.4,0,8.1,3.5,8.1,7.9c0,1.5-0.5,3.1-1.2,4.4c-0.7,1.4-1.5,2.8-2.3,3.9C16.8,20,16,21,15.4,21.7 c-0.3,0.4-0.6,0.7-0.7,0.9c-0.1,0.1-0.2,0.2-0.2,0.2l-0.1,0.1l0,0l0,0l0,0c0,0,0,0-1.3-1.2C13,21.7,13.5,21.1,14.2,20.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8.9,
    y: 6.7,
    width: 8.2,
    height: 8.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13,8.4c-1.3,0-2.4,1.1-2.4,2.4h0.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7h0.7 C15.4,9.5,14.3,8.4,13,8.4z M13,7c-2.1,0-3.8,1.7-3.8,3.8h0.7c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1h0.7C16.8,8.7,15.1,7,13,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.9,10.8c0,0.4-0.2,0.6-0.5,0.8V12h-0.7v-0.4c-0.3-0.1-0.5-0.4-0.5-0.8c0-0.5,0.4-0.9,0.9-0.9 C13.5,9.9,13.9,10.3,13.9,10.8z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.5,12h-0.7h-3.7h-0.7v0.7v3.6V17h0.7h3.7h0.7v-0.7v-3.6V12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.4,13.1H14H12h-0.4v0.4v2v0.4H12H14h0.4v-0.4v-2V13.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 15,
    width: 11,
    height: 11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.4,5.5c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1C18.2,9.6,16.4,7.8,16.4,5.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 14.6,
    y: -0.4,
    width: 11.7,
    height: 11.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.1,5.5c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4S16.1,7.9,16.1,5.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGateawayOnStateUnChecked);
export default __webpack_public_path__ + "static/media/Pin-Gateaway-On State-UnChecked.51a24a2076fb607a39ea3bcd8bbb9122.svg";
export { ForwardRef as ReactComponent };